import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-entity-profile-card',
  template: `
    <section
      class="card entity-search-header entity-profile"
      [attr.aria-label]="name + ' details'"
    >
      <div class="entity-profile__main">
        <img
          *ngIf="imageUrl && !imageFailed"
          class="entity-profile__photo"
          [src]="imageUrl"
          [alt]="name"
          (error)="imageFailed = true"
        />
        <div class="entity-profile__details">
          <ng-content select="[profileTitle]"></ng-content>
          <ng-content select="[profileContacts]"></ng-content>
        </div>
      </div>
      <ng-content select="[profileStats]"></ng-content>
    </section>
  `,
  styleUrls: ['./entity-profile-card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EntityProfileCardComponent {
  @Input() name: string;
  @Input() set picture(value: string) {
    this.imageUrl = value;
    this.imageFailed = false;
  }

  imageUrl: string;
  imageFailed = false;
}
